import {React, observer} from '@api'
import {Tooltip2} from '@api'
import { useStores } from '@design-board'
import {Tooltip} from '@material-ui/core'
import {deployments} from '@stores'
import { CentricLogo } from '@stores/ui'
import {PrimaryIconButton} from 'centric-ui-components'
import * as css from './C8MenuButton.css'

export interface IC8MenuConfig {
  fields: Array<string>
}

export const C8MenuButton = observer<{ className?: string, url?: string, tooltipPlacement?: string }>(({className, url, tooltipPlacement}) => {
  const {strings, config: {config: {centricURL}}, c8} = useStores()

  return centricURL && !deployments.deploymentConfig.hideC8Button ? (
    <Tooltip2 content={strings.openInC8} placement={(tooltipPlacement ?? 'right') as any}>
      <PrimaryIconButton
        wrapperClassName={css.root}
        icon={<CentricLogo className={className} />}
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
          window.open(`${url ?? c8.boardC8Url}`, '_blank');
        }}
        />
    </Tooltip2>) : null
})



// WEBPACK FOOTER //
// ./src/modules/c8/components/C8MenuButton.tsx